import React from "react";
import LocationMeublee from "../components/elements/informationsProjet/activites/LocationMeublee";
import Header from "../components/UI/Header";
import Select from "../components/UI/Select";
import { optionsActivite } from "../utils/selectOptions";

const InformationsProjet = ({
  formData,
  setFormData,
  professional,
  setProfessional,
  professionals,
  setProfessionals,
  proprietaireIndivision,
  setProprietaireIndivision,
  proprietairesIndivision,
  setProprietairesIndivision,
  setValidResponse,
  handleChange,
  inputFocus,
  handleTrimValue,
  page,
  urlAPI,
  ville,
}) => {
  return (
    <>
      <Header title="2. Informations sur le projet" />
      <Select
        label="Quelle activité sera exercée dans le local&nbsp;?"
        selectClassName="page-2-required text-truncate select-activite"
        name="ProActivite"
        value={formData.ProActivite}
        handleChange={handleChange}
        inputFocus={inputFocus}
        datagroup="ProActivite"
        options={optionsActivite}
        isBold={true}
      />
      <div className="mb-5"></div>
      {formData.ProActivite ===
        "Location meublée courte durée (location touristique)" && (
        <LocationMeublee
          formData={formData}
          handleChange={handleChange}
          inputFocus={inputFocus}
          handleTrimValue={handleTrimValue}
          page={page}
          setFormData={setFormData}
          proprietaireIndivision={proprietaireIndivision}
          setProprietaireIndivision={setProprietaireIndivision}
          proprietairesIndivision={proprietairesIndivision}
          setProprietairesIndivision={setProprietairesIndivision}
          setValidResponse={setValidResponse}
          urlAPI={urlAPI}
          ville={ville}
        />
      )}
    </>
  );
};

export default InformationsProjet;
